import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, layout, mq } = theme.custom;
    return {
        root: {
            width: '100%',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            background: color.canvasBackground,
            backgroundColor: color.canvas,
            color: color.text.primary,
            '& > *:not([data-flex-main])': { flexShrink: 0 },
        },
        contentContainer: {
            display: 'flex',
            flex: 1,
            width: '100%',
            minHeight: 0,
            overflow: 'hidden',
            position: 'relative',
        },
        pageContent: {
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: layout.pagePadding,
            [mq.sm]: { padding: layout.pagePaddingMobile },
        },
        pageInner: {
            maxWidth: layout.contentMaxWidth,
            margin: '0 auto',
            minWidth: 0,
        },
        backdrop: {
            position: 'fixed',
            inset: 0,
            backgroundColor: color.overlay,
            zIndex: 1199,
            '@media (min-width: 768px)': { display: 'none' },
        },
    };
});
